import $ from 'domtastic';

const starredItem = {
  create(props) {
    return $(`
      <li class="starred__item js-starred-item">
        <a href="${props.url}" class="starred__link">
          <span class="starred__icon">
            <svg class="icon -star">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use>
            </svg>
          </span>
          <span class="starred__text">
            <strong>${props.title}</strong>
            <small>${props.category}</small>
          </span>
        </a>
        <a href="#" class="starred__remove js-starred-remove" data-slug="${props.slug}">
          <svg class="icon -close">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close"></use>
          </svg>
        </a>
      </li>
    `);
  },
};

export default starredItem;



// WEBPACK FOOTER //
// ./components/markup/starredItem.js